import React from 'react';
import { Box } from '@apia/theme';
import { TResponsiveTableCellRendererProps } from '../types';
import { TAccordionCellRenderer } from './AccordionCell';

const AccordionHTMLCellRenderer: TAccordionCellRenderer<{ html: string }> =
  React.forwardRef<
    HTMLSpanElement,
    TResponsiveTableCellRendererProps<{ html: string }>
  >(
    (
      {
        cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
        column,
        row,
        ...props
      },
      currentRef,
    ) => (
      /**
       * Aca falta el title de la columna
       */
      <Box
        key={column.name}
        className="responsiveTable__accordionElement__column"
      >
        {(column.label || column.name) && (
          <Box as="strong">{column.label ?? column.name}: </Box>
        )}
        <Box
          ref={currentRef as React.RefObject<HTMLTableCellElement>}
          {...props}
          {...cell}
          {...(rendererProps?.html
            ? {
                dangerouslySetInnerHTML: {
                  __html: rendererProps.html.replaceAll(
                    /<TOK(\d+)/g,
                    '&lt;TOK$1',
                  ),
                },
              }
            : { children })}
          as="span"
        />
      </Box>
    ),
  );

export default AccordionHTMLCellRenderer;
